export default __webpack_public_path__ + "static/media/hospital2.4388a3c2.png";